import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../../ReduxToolkit/Store';

const PermissionWrapper: React.FC<{ children: React.ReactNode; permissions?: string[] }> = ({
    children,
    permissions
}) => {
    const userRoles = useSelector((state: RootState) => state.auth.user?.roles);

    if (!permissions || permissions.length === 0) {
        return <>{children}</>;
    }

    // If the user has no roles assigned, deny access.
    if (!userRoles || !Array.isArray(userRoles) || userRoles.length === 0)
        return (
            <Navigate
                to={`${process.env.PUBLIC_URL}/errors/error403`}
                replace
            />
        );

    // Check if the user's roles array contains at least one of the required permission roles.
    const hasPermission = userRoles.some((role) => permissions.includes(role));

    if (!hasPermission) {
        return (
            <Navigate
                to={`${process.env.PUBLIC_URL}/errors/error403`}
                replace
            />
        );
    }

    return <>{children}</>;
};

export default PermissionWrapper;
